export default "__VITE_ASSET__BUAxQDPY__"